import { useEffect, useState } from "react";
import axios from "axios";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/feedback`);
        const fiveStarTestimonials = response.data.filter(item => item.rating === 5);
        setTestimonials(shuffleArray(fiveStarTestimonials).slice(0, 3));
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  // Function to shuffle array randomly
  const shuffleArray = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  return (
    <div className="bg-purple-50 py-14 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-playfair-display text-gray-900 mb-10">Apa Kata Pengguna?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-2xl shadow-lg">
              <p className="text-gray-700 italic">"{testimonial.comment}"</p>
              <div className="mt-4">
                <h3 className="text-lg font-semibold text-gray-900">{testimonial.name}</h3>
                <div className="text-yellow-400 flex justify-center mt-2">
                  {Array(5).fill("⭐").map((star, i) => (
                    <span key={i}>{star}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
